var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "ibox sombra-light" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "ibox-content" }, [
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.getreporte.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "b-overlay",
                { attrs: { show: _vm.buttonDisable, rounded: "sm" } },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Fecha de inicio")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "input-group" },
                          [
                            _c(
                              "b-form-datepicker",
                              _vm._b(
                                {
                                  staticClass: "mb-2",
                                  attrs: {
                                    id: "fechaInicioGrafico",
                                    placeholder: "Fecha de inicio",
                                    locale: _vm.datepicker.idioma,
                                  },
                                  model: {
                                    value: _vm.form.fechaInicio,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "fechaInicio", $$v)
                                    },
                                    expression: "form.fechaInicio",
                                  },
                                },
                                "b-form-datepicker",
                                _vm.datepicker.etiquetas[
                                  _vm.datepicker.idioma
                                ] || {},
                                false
                              )
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Fecha de término")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "input-group" },
                          [
                            _c(
                              "b-form-datepicker",
                              _vm._b(
                                {
                                  staticClass: "mb-2",
                                  attrs: {
                                    id: "fechaTerminoGrafico",
                                    placeholder: "Fecha de término",
                                    locale: _vm.datepicker.idioma,
                                  },
                                  model: {
                                    value: _vm.form.fechaTermino,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "fechaTermino", $$v)
                                    },
                                    expression: "form.fechaTermino",
                                  },
                                },
                                "b-form-datepicker",
                                _vm.datepicker.etiquetas[
                                  _vm.datepicker.idioma
                                ] || {},
                                false
                              )
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "offset-md-6 col-md-6" },
                      [
                        _c(
                          "b-button",
                          {
                            class: "buscar-info-dashboard",
                            attrs: {
                              block: "",
                              variant: "primary",
                              type: "submit",
                              disabled: _vm.buttonDisable,
                            },
                            on: { submit: _vm.getreporte },
                          },
                          [_vm._v("Buscar")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.mostrarGraficos
            ? _c("div", { staticClass: "graficos" }, [
                _c("div", { staticClass: "ibox sombra-light" }, [
                  _c(
                    "div",
                    { staticClass: "ibox-content" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("data-table", {
                                attrs: {
                                  id: _vm.dt.id,
                                  datos: _vm.dt.datos,
                                  columnas: _vm.dt.columnas,
                                  responsive: true,
                                  "font-size": 12,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", [
        _c("i", { staticClass: "fal fa-chart-bar" }),
        _vm._v(" Reporte Preguntas Frecuentes\n            "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }